<template lang="pug">
  div(class="m-change-email")
    h2(
      v-if="!xsDevice"
      class="title-32px bold mb-2"
    ) {{ title }}
    p(
      class="fw-300 mb-8"
      :class="[xsDevice ? 'text-14px' : 'text-16px']"
    )
      template(v-if="currentStep === steps.newEmail") {{ $t('All your documents, templates, and settings will remain unchanged. Only the login address will change') }}
      template(v-else)
        span {{ $t('We sent confirmation code to email') }}:
        span(
          :class="[xsDevice ? 'text-14px' : 'text-16px']"
          class="dark pl-1"
        ) {{ shownEmail }}
    form-current-email-otp-confirm(
      v-if="currentStep === steps.confirmCurrentEmail"
      :task-id="taskId"
      :close-modal="closeModal"
      :initial-loading="loading"
      @nextStep="nextStep"
      @getCodeAgain="onCreated"
    )
    form-new-email(
      v-else-if="currentStep === steps.newEmail"
      :task-id="taskId"
      :close-modal="closeModal"
      @nextStep="nextStep"
      @getNewEmail="newEmail = $event"
    )
    form-new-email-otp-confirm(
      v-else-if="currentStep === steps.confirmNewEmail"
      :task-id="taskId"
      :close-modal="closeModal"
      :new-email="newEmail"
      @success="closeModal(true)"
    )
</template>

<script>
import FormCurrentEmailOtpConfirm from '~/modules/profile/components/forms/form-current-email-otp-confirm'
import FormNewEmailOtpConfirm from '~/modules/profile/components/forms/form-new-email-otp-confirm'
import FormNewEmail from '~/modules/profile/components/forms/form-new-email'
import responsive from '~/mixins/pages/responsive'

export default {
  name: 'MChangeEmail',
  components: {
    FormNewEmail,
    FormCurrentEmailOtpConfirm,
    FormNewEmailOtpConfirm
  },
  mixins: [responsive],
  props: {
    closeModal: {
      type: Function,
      default: null
    },
    setTitle: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      currentStep: 'confirmCurrentEmail',
      newEmail: null,
      taskId: null,
      loading: false
    }
  },
  computed: {
    steps() {
      return {
        confirmCurrentEmail: 'confirmCurrentEmail',
        newEmail: 'newEmail',
        confirmNewEmail: 'confirmNewEmail'
      }
    },
    title() {
      switch (this.currentStep) {
        case 'confirmCurrentEmail':
          return this.$t('Confirmation of current email')
        case 'newEmail':
          return this.$t('New email address')
        case 'confirmNewEmail':
          return this.$t('Підтвердження нової пошти')
        default:
          return null
      }
    },
    shownEmail() {
      return this.currentStep === this.steps.confirmCurrentEmail ? this.$User.email : this.newEmail // todo
    }
  },
  watch: {
    title: {
      handler(val) {
        if (this.xsDevice) {
          this.setTitle(val)
        }
      },
      immediate: true
    }
  },
  created() {
    this.onCreated()
  },
  methods: {
    async onCreated() {
      try {
        this.loading = true
        this.taskId = this._.get(
          await this.$store.dispatch('users/initEmailChange'),
          'data.id',
          null
        )
      } catch (e) {
        this.$handlers.error(e, this)
      } finally {
        this.loading = false
      }
    },
    nextStep() {
      const stepsArray = Object.keys(this.steps)
      const currentStepIdx = this._.findIndex(stepsArray, step => step === this.currentStep)
      this.currentStep = stepsArray[currentStepIdx + 1]
    }
  }
}
</script>

<style scoped lang="scss">
.m-change-email {
  height: 100%;

  @media (min-width: map-get($breakpoints, 'sm')) {
    height: auto;
  }
}
</style>
